import {
  AfterViewInit, Component,
  OnInit, TemplateRef,
  ViewChild
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import * as $ from "jquery";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NgxSpinnerService } from "ngx-spinner";
import { forkJoin, Observable } from "rxjs";
import { ApiService } from "src/app/core/services/shared/api.service";

import { GlobalVarService } from "src/app/core/services/shared/global-var.service";
import { CandidateService } from "../../core/services/candidate/candidate.service";
import { ConsiderService } from "../../core/services/consider/consider.service";
import { VirtueAlertModalComponent } from "../shared/virtuealert/virtuealert.component";
declare var applyOrgCss: Function;

@Component({
  selector: "app-homepage",
  templateUrl: "./homepage.component.html",
  styleUrls: ["./homepage.component.scss"],
  providers: [CandidateService, NgxSpinnerService, ConsiderService],
})
export class HomepageComponent implements OnInit, AfterViewInit {
  @ViewChild("virtueAlertModal") childModal: VirtueAlertModalComponent;

  eyeCss = "fa fa-fw fa-eye field-icon";
  pwdType = "password";
  togglepwdicon: boolean = false;
  clientName: string = "";
  paymentSubscriptionCode: string = "";
  subscriptionError: boolean = false;


  hasSubscription: boolean = false;
  isVirtue: boolean = false;
  video: string = "";
  modalRef: BsModalRef;
  stats: any = [
    {
      statsFirst: "Average Net Price",
      statsCount: "13.7",
      statsCountPref: "k",
      statsLast: "freshman year",
    },
    {
      statsFirst: "Approx.",
      statsCount: "86",
      statsCountPref: "%",
      statsLast: "undergrads receiving aid",
    },
    {
      statsFirst: "Average Income",
      statsCount: "54.7",
      statsCountPref: "k",
      statsLast: "with undergraduate degree",
    },
  ];

  constructor(
    private _candidateService: CandidateService,
    public globalvar: GlobalVarService,
    // private apiService: apiService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private spinnerService: NgxSpinnerService,
    private router: Router,
    private modalService: BsModalService
  ) {
    
  }

  showVirtueAlert(): void {
    this.childModal.show();
  }

  hideVirtueAlert(): void {
    this.childModal.hide();
  }

  ngAfterViewInit() {
    $(".count").each(function () {
      $(this)
        .prop("Counter", 0)
        .animate(
          {
            Counter: $(this).text(),
          },
          {
            duration: 500,
            easing: "swing",
            step: function (now) {
              $(this).text(Math.ceil(now));
            },
          }
        );
    });
  }

  ngOnInit() {
   

  }


  clearSession() {
    this._candidateService.distroySession().subscribe((res) => {
      this.router.navigate(["/profile"], { relativeTo: this.route });
    });
  }

  getUniversityData(): Observable<any> {
    const resProviderUniversityStateItem =
      this.apiService.getProviderUniversityState();
    const resProviderUniversityItem =
      this.apiService.getProviderUniversity();
    return forkJoin([
      resProviderUniversityStateItem,
      resProviderUniversityItem,
    ]);
    //@ts-ignore
    // return forkJoin({stateItem:resProviderUniversityStateItem,uniItem: resProviderUniversityItem});
  }

  togglepwd() {
    this.togglepwdicon = !this.togglepwdicon;
    if (this.togglepwdicon) {
      this.eyeCss = "fa fa-fw fa-eye fa-eye-slash field-icon";
      this.pwdType = "text";
    } else {
      this.eyeCss = "fa fa-fw fa-eye field-icon";
      this.pwdType = "password";
    }
  }

  subscriptionInfoClick(radio: boolean) {
    this.hasSubscription = radio;
  }

  openModalWithClass(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "gray modal-lg" })
    );
  }
}
